import { Phone } from "lucide-react";
import { motion } from "framer-motion";

export default function CallButton() {
  return (
    <motion.a
      href="tel:+97145723353"
      aria-label="Call Optrenex"
      data-testid="call-button"
      className="fixed bottom-8 right-[6.5rem] z-50 w-14 h-14 rounded-full bg-cyan flex items-center justify-center shadow-[0_4px_24px_rgba(86,205,236,0.4)] transition-transform duration-300"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 2.15, type: "spring", stiffness: 200 }}
      whileHover={{ scale: 1.15 }}
      whileTap={{ scale: 0.95 }}
    >
      <Phone size={24} className="text-[#03222d]" />
    </motion.a>
  );
}
